var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"bus",attrs:{"formParams":_vm.formParams,"reMountPage":_vm.reMountPage,"opCode":_vm.opCode,"funcOnChange":_vm.bindAreaFlag,"funcKeyUp":_vm.bindKeyUpInterface,"funcClick":_vm.bindClickInterface}})
}
var staticRenderFns = []

export { render, staticRenderFns }